import styles from "./CoverSection.module.scss";

interface CoverSectionProps {
    propertyName: string;
    streetAddress?: string;
    city?: string;
    stateProvince?: string;
    postalZipCode?: string;
    analysisDate: string;
}

function CoverSection({
    propertyName,
    streetAddress,
    city,
    stateProvince,
    postalZipCode,
    analysisDate,
}: CoverSectionProps) {
    const addressParts = [streetAddress, [city, stateProvince].filter(Boolean).join(", "), postalZipCode].filter(
        Boolean
    );

    const formattedDate = new Date(analysisDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });

    return (
        <div className={styles.root}>
            <h1 className={styles.title}>{propertyName}</h1>
            {addressParts.length > 0 && <p className={styles.address}>{addressParts.join(", ")}</p>}
            <p className={styles.analysisDate}>
                Analysis completed: <span className={styles.dateHighlight}>{formattedDate}</span>
            </p>
            <hr className={styles.divider} />
        </div>
    );
}

export default CoverSection;
